import { App, Button, Divider, Modal, Space, Typography, theme } from "antd";
import { useBilling } from "../Kitchen/billingProvider";
import { useCurrency } from "../../provider/courtryProvider";
import { MdOutlineClose } from "react-icons/md";
import { InputAdornment, TextField } from "@material-ui/core";
import { BsCash, BsCreditCard2Back } from "react-icons/bs";
import ReactToPrint from "react-to-print";
import { useCallback, useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import UPISVG from "../../assets/icons/UPISVG.svg";
import { useDispatch, useSelector } from "react-redux";
import config from "../../config";
import { useCustomerData } from "../../provider/billingProviders/customerDataProvider";
import { useFooterData } from "../../provider/billingProviders/footerDataProvider";
import { v4 as uuid } from "uuid";
import { useCounterId } from "../../provider/counterProvider";
import moment from "moment";
import InvoiceTemplate from "./InvoiceTemplate";
import { useBillingDraftWithCatch } from "../../provider/billingDraftProvider";
import { GENERATEBILLACCESS } from "../../utils/constant";
import { useAccess } from "../../provider/AccessProvider";
import { useKotDraftB2bWithCatch } from "../Kitchen/KOT/kotDraftB2bProvider";
import { useKotDraftWithCatch } from "../Kitchen/KOT/draftProvider";

const initialPaymentState = {
  cash: "",
  card: "",
  upi: "",
};
const ConfirmModal = ({ open, onClose }) => {
  const {
    state: { addedProducts, b2bBill, orderType = "", orderId = "" },
    getSubTotal,
    clearAll,
    setOrderTypeAndId,
  } = useBilling();
  const subTotal = getSubTotal();
  const confirmRef = useRef();
  const { customerData, clearCustomerData } = useCustomerData();
  const { footerData, clearFooterData, getTotalAmount, getRoundOff } =
    useFooterData();
  const total = getTotalAmount();
  const currencyFormatter = useCurrency();
  const printRef = useRef();
  const [counterId] = useCounterId();
  const [, setDraftBillCatch] = useBillingDraftWithCatch();
  const [, setDraftBillB2bCatch] = useKotDraftB2bWithCatch();
  const [, setKotDraftCatch] = useKotDraftWithCatch();
  const [cardType, setCardType] = useState({
    cardType: "",
    lastFourDigit: "",
  });
  const { modal: toastModal } = App.useApp();
  const { useToken } = theme;
  const {
    token: { colorPrimary },
  } = useToken();
  const access = useAccess(GENERATEBILLACCESS);
  const taxList = useSelector((state) => state.taxList.taxList);
  const { productList: products } = useSelector((state) => state.products);
  const dispatch = useDispatch();
  const shopDetails = useSelector((state) => state.shopDetails);
  const [billLoading, setBillLoading] = useState(false);
  const [isSms, setIsSms] = useState(false);
  const { uniqueIdentity: identifier = false } = useSelector(
    (state) => state.shopDetails?.advanceSettings || {}
  );
  const tempState = useSelector((state) => state.newInvoicesettings.tempState);
  const invoiceSettings = useSelector(
    (state) => state.newInvoicesettings.newInvoicesettings
  );
  // const [payload, setPayload] = useState({});

  const [creditSale, setCreditSale] = useState(false);
  const [paymentMode, setPaymentMode] = useState(initialPaymentState);
  const [billPayload, setBillPayload] = useState({});
  const [billPaidAndDueAmount, setBillPaidAndDueAmount] = useState(() => {
    return {
      paidAmount: 0,
      dueAmount: total,
    };
  });
  const roundOff = getRoundOff();
  const reactToPrintContent = useCallback(() => {
    return printRef.current;
  }, []);

  const validator = async (isSms = false) => {
    if (
      customerData.customerPhoneNumber === "" &&
      billPaidAndDueAmount.dueAmount > 0
    ) {
      return alert("Please enter customer details for credit sales.");
    }
    if (shopDetails.shopType === "Restaurant" && !orderType) {
      return alert("Please select Order Type");
    }
    if (!creditSale) {
      if (!paymentMode.upi && !paymentMode.card && !paymentMode.cash) {
        return alert("Please Enter The Received Amount");
      }
    }
    const paymentModeValues = [];
    Object.keys(paymentMode).forEach((i) => {
      let value = {
        method: i,
        paidAmount: paymentMode[i] ? parseFloat(paymentMode[i]) : 0,
      };
      if (i === "card" && paymentMode[i]) {
        value = {
          method: i,
          paidAmount: paymentMode[i] ? parseFloat(paymentMode[i]) : 0,
          cardType: cardType.cardType,
          cardNumber: cardType.lastFourDigit,
        };
      }
      if (paymentMode[i]) {
        paymentModeValues.push(value);
      }
    });
    const payloadData = {
      ...customerData,
      ...footerData,
      shopId: shopDetails.shopId,
      shopName: shopDetails.shopName,
      shopAddress: shopDetails.shopAddress,
      isSms: isSms,
      billId: uuid(),
      customerName:
        customerData.customerName === "" ? "NA" : customerData.customerName,
      customerPhoneNumber:
        customerData.customerPhoneNumber === ""
          ? "NA"
          : `${shopDetails.country.dialCode}${customerData.customerPhoneNumber}`,
      customerDetailsEnabled: true,
      ...(invoiceSettings.roundOff && {
        roundOff: roundOff,
      }),
      ...(shopDetails.shopType === "Restaurant" && {
        orderId: orderId,
        orderType: orderType,
      }),
      billingDate: moment().format("YYYY-MM-DD"),
      billingTime: moment().format("HH:mm"),
      items: addedProducts,
      billVersion: 1,
      paymentMethod: paymentModeValues,
      employeeName: shopDetails.employeeName,
      invoiceNumber: invoiceSettings.currentInvoiceNumber,
      productTotal: total,
      balanceAmount: billPaidAndDueAmount.dueAmount,
      subTotal: subTotal,
      taxAmount: 0,
      cameFrom: "NA",
      extraFields: {
        wastage: false,
        labour: false,
        tax: invoiceSettings.itemleveltax,
        discount: invoiceSettings.itemdiscount,
        hsnCode: invoiceSettings.hsncode,
        mrp: invoiceSettings.itemmrp,
        otherCharges: invoiceSettings.othercharges,
      },
      remainder: "",
      tAndC: invoiceSettings.termscondition ? invoiceSettings.tAndCField : "",
      paymentTerms: invoiceSettings.paymenyterms
        ? invoiceSettings.paymentTermsField
        : "",
      invoicePrefix: invoiceSettings.invoiceprefix
        ? invoiceSettings.invoicePrefixtext
        : "",
      printerType: invoiceSettings.printerType,
      cardType: cardType.cardType,
      cardNumber: cardType.lastFourDigit,
      employeeId: shopDetails.empId ? shopDetails.empId : "",
      counterId: counterId,
      ...(b2bBill && { b2bBill: b2bBill }),
      ...(Boolean(identifier && customerData.uniqueId) && {
        uniqueIdentity: customerData.uniqueId,
      }),
      ...(["Employee", "Outlet"].includes(shopDetails.userType) && {
        parentShopId: shopDetails.ownerShopId,
      }),
    };
    console.log("payloadData", payloadData);
    setBillPayload(payloadData);
    //setPayload(payload);
    setBillLoading(true);
    generateBill(payloadData);
  };

  const generateBill = async (payload) => {
    try {
      const response = await fetch(
        `${config.newApiGateway}/bill/generateBill`,
        {
          method: "POST",
          body: JSON.stringify(payload),
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
        }
      );
      const res = await response.json();
      if (res.code === "SUCCESS") {
        confirmRef.current.click();
        if (tempState) {
          const res = await fetch(
            `${config.newApiGateway}/customer/createCustomerandgetCustomer`,
            {
              method: "POST",
              body: JSON.stringify({
                shopId: shopDetails.shopId,
                action: "getShopDetails",
              }),
              headers: {
                "x-api-key": `${config.newApiKey}`,
                "Content-Type": "application/json",
              },
            }
          );
          const data = await res.json();
          const billingSettings = data.Items[0].newBillsettings;
          const arrToObj = Object.assign({}, ...billingSettings);
          dispatch({
            type: "INVOICE-NEWBILLSETTINGS",
            payload: arrToObj,
          });
        }
        const UpdatedProductList = products.map((i) => {
          const getObj = addedProducts.find((j) => i.productId === j.productId);
          if (getObj) {
            if (b2bBill) {
              return {
                ...i,
                b2bProductPrice: getObj.productPrice,
                inventoryQty:
                  parseFloat(i.inventoryQty) - parseFloat(getObj.count),
              };
            }
            return {
              ...i,
              productPrice: getObj.productPrice,
              inventoryQty:
                parseFloat(i.inventoryQty) - parseFloat(getObj.count),
            };
          }
          return i;
        });
        dispatch({
          type: "SET_PRODUCT_LIST",
          payload: UpdatedProductList,
        });
        dispatch({
          type: "UPDATE_INVOICE_NUMBER",
          payload: res.nextInvoiceNumber,
        });

        console.log("tempState222", tempState);
      }
    } catch (error) {
      if (error.message === "Failed to fetch") {
        if (shopDetails.shopType === "Restaurant" && b2bBill === false) {
          const dBill = {
            billId: uuid(),
            orderId: "",
            items: addedProducts,
            customerData: customerData,
            footerData: footerData,
            customerName: customerData.customerName,
            customerPhoneNumber: customerData.customerPhoneNumber,
            orderType: orderType,
            billingDate: moment().format("YYYY-MM-DD"),
            billingTime: moment().format("HH:mm"),
            totalAmount: getTotalAmount(),
            numberOfItems: addedProducts.length,
            tableNumber: "",
            waiterName: "",
            shopId: shopDetails.shopId,
            action: "restaurant",
            ...(shopDetails.ownerShopId && {
              parentShopId: shopDetails.ownerShopId,
            }),
          };
          setKotDraftCatch((prev) => [...prev, dBill]);
        } else if (shopDetails.shopType === "Restaurant" && b2bBill) {
          const dBill = {
            billId: uuid(),
            orderId: orderId,
            items: addedProducts,
            customerName: customerData.customerName,
            customerPhoneNumber: customerData.customerPhoneNumber,
            orderType: orderType,
            billingDate: moment().format("YYYY-MM-DD"),
            billingTime: moment().format("HH:mm"),
            totalAmount: getTotalAmount(),
            numberOfItems: addedProducts.length,
            tableNumber: "",
            waiterName: "",
            customerData: customerData,
            footerData: footerData,
            shopId: shopDetails.shopId,
            action: "restaurant-b2b",
            ...(shopDetails.ownerShopId && {
              parentShopId: shopDetails.ownerShopId,
            }),
          };
          console.log("dBill333", dBill);
          setDraftBillB2bCatch((prev) => [...prev, dBill]);
        } else {
          if (b2bBill) {
            const dBill = {
              customerData: customerData,
              footerData: footerData,
              billId: uuid(),
              items: addedProducts,
              customerName: customerData.customerName,
              customerPhoneNumber: customerData.customerPhoneNumber,
              billingDate: moment().format("YYYY-MM-DD"),
              billingTime: moment().format("HH:mm"),
              totalAmount: total,
              numberOfItems: addedProducts.length,
              shopId: shopDetails.shopId,
              ...(shopDetails.ownerShopId && {
                parentShopId: shopDetails.ownerShopId,
              }),
              action: "draft-b2b",
            };
            setDraftBillCatch((prev) => [...prev, dBill]);
          } else {
            const dBill = {
              customerData: customerData,
              footerData: footerData,
              billId: uuid(),
              items: addedProducts,
              customerName: customerData.customerName,
              customerPhoneNumber: customerData.customerPhoneNumber,
              billingDate: moment().format("YYYY-MM-DD"),
              billingTime: moment().format("HH:mm"),
              totalAmount: total,
              numberOfItems: addedProducts.length,
              ...(shopDetails.ownerShopId && {
                parentShopId: shopDetails.ownerShopId,
              }),
              action: "draft",
              shopId: shopDetails.shopId,
            };
            console.log("dBill555", dBill);
            setDraftBillCatch((prev) => [...prev, dBill]);
          }
        }
        alert(
          "Billing generation failed. Please check your internet connection. Your previous bill has stored in draft"
        );
      }
      console.error(error);
    } finally {
      setBillLoading(false);
      clearAll();
      clearCustomerData();
      clearFooterData();
      onClose();
      setIsSms(false);
      setOrderTypeAndId("dine_in", "");
    }
  };

  useEffect(() => {
    const amountPaid =
      (parseFloat(paymentMode.card) || 0) +
      (parseFloat(paymentMode.cash) || 0) +
      (parseFloat(paymentMode.upi) || 0);
    const dueAmount = total - amountPaid;
    setBillPaidAndDueAmount({
      paidAmount: amountPaid,
      dueAmount: dueAmount,
    });
  }, [paymentMode.card, paymentMode.cash, paymentMode.upi, total]);

  return (
    <Modal
      centered
      open={open}
      closable={false}
      footer={false}
      width={700}
      maskStyle={{
        backgroundColor: "rgb(0 0 0 / 26%)",
      }}
    >
      <div className="multiplePaymentMainContainer">
        <div className="totalAmountContainer">
          <div className="totalAmountContainerInnerContainer">
            <div>Total</div>
            <div>Amount</div>
            <div style={{ color: "#208441" }}>
              {parseFloat(total).toFixed(2)}
            </div>
            <div
              style={{
                position: "absolute",
                bottom: "0",
                left: "0",
                margin: "20px",
              }}
            >
              <div style={{ textAlign: "center" }}>
                <div style={{ fontSize: "17px", fontWeight: "400" }}>
                  Paid Amount
                </div>
                <div
                  style={{
                    fontSize: "17px",
                    fontWeight: "400",
                    color: "#208441",
                  }}
                >
                  {billPaidAndDueAmount.paidAmount
                    ? billPaidAndDueAmount.paidAmount.toFixed("2")
                    : "0.0"}
                </div>
              </div>
            </div>
            <div style={{ position: "absolute", bottom: "0", right: "0" }}>
              <div style={{ margin: "20px" }}>
                <div className="balanceAmountNewTitle">
                  {billPaidAndDueAmount.dueAmount > 0 ? (
                    "Balance"
                  ) : billPaidAndDueAmount.dueAmount <= 0 ? (
                    "Remaining"
                  ) : (
                    <></>
                  )}
                </div>
                <div className="balanceAmountNewAmount">
                  {billPaidAndDueAmount.dueAmount > 0 ? (
                    <>
                      -
                      {currencyFormatter(
                        Math.abs(billPaidAndDueAmount.dueAmount)
                      )}
                    </>
                  ) : billPaidAndDueAmount.dueAmount <= 0 ? (
                    <>
                      {currencyFormatter(
                        Math.abs(billPaidAndDueAmount.dueAmount).toFixed("2")
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                </div>{" "}
              </div>{" "}
            </div>
          </div>
        </div>

        <div className="paymentTextfieldsContainer">
          <div
            className={
              billLoading
                ? "paymentTextfieldsClosureDisable"
                : "paymentTextfieldsClosure"
            }
            disabled={billLoading}
            onClick={() => {
              onClose();
            }}
          >
            <MdOutlineClose />
          </div>
          <div className="paymentTextfieldsTitle">Payment Methods</div>
          <div className="textFieldsContainer">
            <div className="cashFieldSection">
              <TextField
                onChange={(e) => {
                  setPaymentMode((prev) => ({
                    ...prev,
                    cash: e.target.value,
                  }));
                }}
                size="small"
                variant="outlined"
                label="Cash Payment"
                placeholder="Enter Cash Amount"
                value={paymentMode.cash}
                name="billPaidAmount"
                type="number"
                fullWidth={true}
                disabled={creditSale}
                id="cash"
                inputProps={{
                  step: ".01",
                  maxLength: 8,
                  pattern: "/[A-Za-z]{3}/",
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <BsCash style={{ fontSize: "45px" }} />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div className="upiFieldSection">
              <TextField
                onChange={(e) => {
                  setPaymentMode((prev) => ({
                    ...prev,
                    upi: e.target.value,
                  }));
                }}
                value={paymentMode.upi}
                name="billPaidAmount"
                type="number"
                placeholder="Enter UPI Amount"
                disabled={creditSale}
                id="upi"
                size="small"
                variant="outlined"
                label="UPI Payment"
                fullWidth={true}
                inputProps={{
                  maxLength: 8,
                  pattern: "/[A-Za-z]{3}/",
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <img src={UPISVG} width={50} height={50} alt="" />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div className="cardFieldSection">
              <TextField
                onChange={(e) => {
                  setPaymentMode((prev) => ({
                    ...prev,
                    card: e.target.value,
                  }));
                }}
                id="card"
                value={paymentMode.card}
                name="billPaidAmount"
                placeholder="Enter Card Amount"
                disabled={creditSale}
                size="small"
                variant="outlined"
                label="Card Payment"
                fullWidth={true}
                style={{
                  borderRadius: "10px !important",
                }}
                type="number"
                inputProps={{
                  maxLength: 8,
                  pattern: "/[A-Za-z]{3}/",
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <BsCreditCard2Back style={{ fontSize: "45px" }} />
                    </InputAdornment>
                  ),
                }}
              />
              <div className="chooseCardTypeSection">
                <div>
                  <select
                    onChange={(e) => {
                      setCardType((prev) => ({
                        ...prev,
                        cardType: e.target.value,
                      }));
                    }}
                    className="selectOfChooseCardType"
                  >
                    <option value="">Card type</option>
                    <option value="visa">Visa</option>
                    <option value="masterCard">Master Card</option>
                    <option value="platinum">Rupay</option>
                  </select>
                </div>
                <div>
                  <input
                    style={{ width: "176px" }}
                    className="inputOfChooseCardType"
                    disabled={creditSale}
                    type="number"
                    placeholder="Enter last 4 digits"
                    value={cardType.cardNumber}
                    onChange={(e) => {
                      setCardType((prev) => ({
                        ...prev,
                        lastFourDigit: e.target.value,
                      }));
                    }}
                    maxLength={4}
                  />
                </div>
              </div>
            </div>
            {shopDetails.shopType === "Restaurant" && (
              <div>
                <div
                  style={{
                    marginTop: " -1.5rem",
                  }}
                >
                  <select
                    onChange={(e) => {
                      setOrderTypeAndId(e.target.value, null);
                    }}
                    style={{
                      width: "100%",
                      cursor: orderType && orderId ? "not-allowed" : "pointer",
                    }}
                    disabled={orderType && orderId}
                    className="selectOfChooseCardType"
                    value={orderType}
                  >
                    <option value="">Order type</option>
                    <option value="dine_in">Dine In</option>
                    <option value="parcel">Parcel</option>
                    <option value="delivery">Delivery</option>
                  </select>
                </div>
              </div>
            )}
            <div className="creditFieldSection">
              <div>
                <Divider
                  style={{
                    borderTopWidth: "2px",
                    borderColor: "gray",
                    fontSize: "14px",
                    color: "gray",
                  }}
                >
                  Or Pay It Later By Credit Sale
                </Divider>
              </div>
              <div
                style={
                  customerData.customerPhoneNumber === ""
                    ? { textAlign: "center", cursor: "not-allowed" }
                    : { textAlign: "center" }
                }
              >
                {/* <input
                    type="checkbox"
                    onClick={() => {
                      setCreditSale(!creditSale);
                    }}
                  /> */}
                <input
                  id="credit-sales"
                  type="radio"
                  style={
                    customerData.customerPhoneNumber === ""
                      ? { cursor: "not-allowed", marginRight: "4px" }
                      : { marginRight: "4px" }
                  }
                  onClick={() => {
                    const isCreditSalesAccess = access.creditSales(false);
                    if (!isCreditSalesAccess) {
                      toastModal.error({
                        title: "Access Denied",
                        content:
                          "You do not have access to perform credit sales. Please contact your administrator to request the appropriate access.",
                        width: 500,
                        okButtonProps: {
                          type: "primary",
                          style: {
                            background: colorPrimary,
                          },
                        },
                      });
                      return;
                    }
                    setCreditSale(!creditSale);
                    setPaymentMode(initialPaymentState);
                  }}
                  checked={creditSale}
                  disabled={customerData.customerPhoneNumber === ""}
                />
                <label
                  style={
                    customerData.customerPhoneNumber === ""
                      ? { cursor: "not-allowed" }
                      : {}
                  }
                  for={"credit-sales"}
                >
                  Credit Sale
                </label>
              </div>
            </div>
            <div>
              <div style={{ textAlign: "center", marginTop: "10px" }}>
                <Typography.Text type="danger">
                  {shopDetails.smsPackage === "yes" ? (
                    shopDetails.smsCount <= 0 ? (
                      <NavLink
                        style={{
                          color: "red",
                          textDecoration: "underline",
                        }}
                        to="/dashboard/plan-and-pricing"
                      >
                        You consumed all the SMS, Recharge again
                      </NavLink>
                    ) : (
                      ""
                    )
                  ) : (
                    <>
                      <NavLink
                        style={{
                          color: "red",
                          textDecoration: "underline",
                        }}
                        to="/dashboard/plan-and-pricing"
                      >
                        Activate
                      </NavLink>{" "}
                      <Typography.Text>the SMS package for SMS</Typography.Text>
                    </>
                  )}
                </Typography.Text>

                <Space
                  style={{
                    height: 40,
                  }}
                  direction="horizontal"
                >
                  <Button
                    size="large"
                    type="primary"
                    style={{
                      width: 140,
                    }}
                    disabled={billLoading}
                    onClick={() => {
                      const isCreditSalesAccess = access.creditSales(false);
                      if (
                        billPaidAndDueAmount.dueAmount > 0 &&
                        !isCreditSalesAccess
                      ) {
                        toastModal.error({
                          title: "Access Denied",
                          content:
                            "You do not have access to perform credit sales. Please contact your administrator to request the appropriate access.",
                          width: 500,
                          okButtonProps: {
                            type: "primary",
                            style: {
                              background: colorPrimary,
                            },
                          },
                        });
                        return;
                      }
                      validator(false);
                    }}
                    loading={!!(!isSms && billLoading)}
                  >
                    Print
                  </Button>
                  <Button
                    type="primary"
                    disabled={
                      billLoading ||
                      shopDetails.smsPackage === "no" ||
                      !shopDetails.smsPackage ||
                      shopDetails.smsCount <= 0
                    }
                    onClick={() => {
                      const isCreditSalesAccess = access.creditSales(false);
                      if (
                        billPaidAndDueAmount.dueAmount > 0 &&
                        !isCreditSalesAccess
                      ) {
                        toastModal.error({
                          title: "Access Denied",
                          content:
                            "You do not have access to perform credit sales. Please contact your administrator to request the appropriate access.",
                          width: 500,
                          okButtonProps: {
                            type: "primary",
                            style: {
                              background: colorPrimary,
                            },
                          },
                        });
                        return;
                      }
                      const isSendSms = access.sendSms(false);
                      if (!isSendSms) {
                        toastModal.error({
                          title: "Access Denied",
                          content:
                            "You do not have access to perform Print + SMS. Please contact your administrator to request the appropriate authorization.",
                          width: 500,
                          okButtonProps: {
                            type: "primary",
                            style: {
                              background: colorPrimary,
                            },
                          },
                        });
                        return;
                      }
                      if (
                        !customerData.customerPhoneNumber ||
                        !customerData.customerName
                      ) {
                        alert("Please enter customer details for Sms");
                        return;
                      }
                      validator(true);
                      setIsSms(true);
                    }}
                    style={{
                      width: 140,
                    }}
                    size="large"
                    loading={!!(isSms && billLoading)}
                  >
                    Print + SMS
                  </Button>
                  <ReactToPrint
                    trigger={() => {
                      return (
                        <button
                          ref={confirmRef}
                          style={{
                            visibility: "hidden",
                            width: 1,
                            maxWidth: 1,
                            padding: 0,
                            height: 1,
                          }}
                          // disabled={billLoading}
                          className="confirmBillNew"
                        >
                          Confirm
                        </button>
                      );
                    }}
                    content={reactToPrintContent}
                    onAfterPrint={() => {
                      // setBillConfirm(false);
                      // setBillLoading(false);
                      // setNotes("");
                    }}

                    // onBeforePrint={handleBeforePrint}
                  />
                </Space>
                {billLoading && (
                  <>
                    <InvoiceTemplate
                      ref={printRef}
                      data={{
                        invoiceSettings: invoiceSettings,
                        settings: {
                          otherChargesField: footerData.otherCharges,
                        },
                        products: addedProducts,
                        result: {
                          roundOffAmount: billPayload.roundOff,
                          billSubTotal: subTotal,
                          couponDiscountAmount: footerData.couponDiscountAmount,
                          invoiceNumber: invoiceSettings.currentInvoiceNumber,
                          invoicePrefixField: invoiceSettings.invoicePrefixtext,
                          billFinalTotal: total,
                        },
                        shopDetails: shopDetails,
                        discountType: {
                          billDiscountType: footerData.discountType,
                        },
                        loyaltyDiscount: customerData.loyaltyDiscount,
                        loyaltyPoints: customerData.loyaltyPoints,
                        couponObj: footerData.coupon,
                        loyaltyObj: customerData.loyalty,
                        taxList: taxList,
                        paymentMethod: creditSale
                          ? ["credit"]
                          : billPayload.paymentMethod.map((p) => {
                              return p.method;
                            }),
                        billInput: {
                          billDiscount: footerData.discount,
                          billDiscountType: footerData.discountType,
                          billPaid: billPaidAndDueAmount.paidAmount,
                          billAmountDue: billPaidAndDueAmount.dueAmount,
                          notes: footerData.notes,
                        },
                        customerDetails: {
                          customerPhoneNumber: billPayload.customerPhoneNumber,
                          customerName: billPayload.customerName,
                        },
                        deliveryAddress: footerData.shippingAddress
                          ? footerData.shippingAddress
                          : footerData.billingAddress
                          ? footerData.billingAddress
                          : "",
                        billingAddress: footerData.billingAddress,
                        orderType: orderType,
                      }}
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
